import { gql } from '@apollo/client';

export const GET_SORTER_PLAN = gql`
  query GetSorterPlan($id: Long!) {
    getSorterPlan(id: $id) {
      id
      sorterId
      warehouseId
      sorterPlanName
      status
      version
      isDropBag
      isSpecified
      printCount
    }
  }
`;

export interface SorterPlan {
  id: number;
  sorterId?: number;
  warehouseId?: number;
  sorterPlanName?: string;
  status: number;
  version: number;
  isDropBag: boolean;
  isSpecified: boolean;
  printCount: number;
  sorterType?: number;
}

export interface GetSorterPlanData {
  getSorterPlan: SorterPlan | null;
}

export interface GetSorterPlanVariables {
  id: number;
}
